'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var TextView = require('./text').default;
var SelectView = require('./select').default;
var CheckListView = require('./check-list').default;
var RadioListView = require('./radio-list').default;
var TextAreaView = require('./text-area').default;

require('select2');

export default Marionette.View.extend({

  className: 'form-row',

  template: require('./templates/response.hbs'),

  attributes: {
    class: 'input question',
  },

  ui: {
    question: '.form-question',
  },

  types: {
    1: 'text',
    2: 'select',
    3: 'checkbox',
    4: 'radio',
    5: 'textarea',
  },

  answer: null,

  initialize: function (options) {
    this.question = this.model.get('question');

    if (this.model.has('answer')) {
      this.answer = this.model.get('answer').value;
    }

    let answers = {};
    if (options.client && options.client.has('answers')) {
      answers = options.client.get('answers');
    } else if (window.SETTINGS.copy_multiple_attendees_answers
      && options.parentModel && options.parentModel.has('answers')) {
      answers = options.parentModel.get('answers');
    }

    const questionId = this.question.get('id').toString();
    if (Object.keys(answers).includes(questionId)) {
      this.answer = JSON.parse(JSON.stringify(answers[questionId].value));
    }

    this._setupViews();
  },

  _setupViews: function () {
    var field;
    switch (this.types[this.question.get('type')]) {
      case 'text':
        field = new TextView({responseId: this.model.cid, question: this.question, answer: this.answer});
        break;
      case 'select':
        field = new SelectView({responseId: this.model.cid, question: this.question, answer: this.answer});
        break;
      case 'checkbox':
        field = new CheckListView({responseId: this.model.cid, question: this.question, answer: this.answer});
        break;
      case 'radio':
        field = new RadioListView({responseId: this.model.cid, question: this.question, answer: this.answer});
        break;
      case 'textarea':
        field = new TextAreaView({responseId: this.model.cid, question: this.question, answer: this.answer});
        break;
    }

    this.field = field;
  },

  serializeData: function () {
    return {
      label: this.question.get('label'),
      id: this.question.get('id'),
      required: this.question.get('required')
    };
  },

  onRender: function () {
    this.ui.question.append(this.field.render().el);
  },

  onDomRefresh: function() {
    if (this.types[this.question.get('type')] == 'select') {
      var $select = this.ui.question.find('select');
      var $placeholder = this.question.get('placeholder');

      $select.select2({
        placeholder: $placeholder ? $placeholder : '',
        allowClear: true,
      });
    }
  },
});
